import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import {
  trackWidgetStep,
  trackWidgetContact,
  trackWidgetSubmit,
  widgetStepIndex,
} from "../analytics/widgetTracking.js";

import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";

import PrimaryButton from "../buttons/PrimaryButton.js";
import { useSnackbar } from "notistack";
import { Timestamp } from "firebase/firestore";
import { addDays } from "date-fns";
// Example object where you want to set the timestamp

import {
  getArrayDocDataByRef,
  queryCollection,
  getDocDataByRef,
  getDocDataById,
} from "../models/DataFunctions.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import { set } from "date-fns";
import createNewDevis from "../api/create/createNewDevis.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import { format } from "date-fns";
import { useAppContext } from "../config/AppContext.js";
import sendDV1 from "../api/sign/sendDV1.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import { InputNumber, Spin } from "antd";
import Modal1 from "../modals/Modal1.js";
import uploadDropZoneTemporary from "../api/upload/uploadDropZoneTemporary.js";
import transferInvoiceFiles from "../api/folder/transferInvoiceFiles.js";
import FillFormModal from "../modals/FillFormModal.js";
import WarningButton from "../buttons/WarningButton.js";

import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import createDocApi from "../api/database/createDocApi.js";
import TimelineNewInvoice from "../folder_modals/TimelineNewInvoice.js";
import Dropzone2 from "../dropzones/DropZone2.js";
import sendFormDevis from "../api/send/sendFormDevis.js";
import NewInvoiceForm from "./NewInvoiceForm.js";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3.js";
import TextField2T from "../textfields/TextField2T.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import RecaptchaComponent from "../embed/RecaptchaComponent.js";
import sendEmailDraftInvoiceCreated from "../api/send/sendEmailDraftInvoiceCreated.js";
import MLTFGPT3 from "../textfields/MLTFGPT3.js";

function NewInvoiceClient({
  userData,
  orgData,
  navigateWorkspace,
  iframe = false,
}) {
  let mobile = iframe?.deviceWidth < 768;
  const { currentUser, loading } = useAuth();
  const [client_selected = null, setClientSelected] = useState(null);
  const [client, setClient] = useState(null);
  const [master, setMaster] = useState(null);
  const [needed_files, setNeededFiles] = useState([]);
  const [clients_name_options, setClients_options] = useState([]);
  const [clients, setClients] = useState([]);
  const [article_configuration, setArticle_configuration] = useState({
    step: 0,
    units: 1,
    surface: "",
  });
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [display_final, setDisplayFinal] = useState(false);
  // State variables to store the input values
  const [adresse_projet, setAdresse_projet] = useState("");
  const [code_postal_projet, setCode_postal_projet] = useState("");
  const [ville_projet, setVille_projet] = useState("");
  const [adresse_maitre_ouvrage, setAdresse_maitre_ouvrage] = useState("");
  const [code_postal_maitre_ouvrage, setCode_postal_maitre_ouvrage] =
    useState("");
  const [ville_maitre_ouvrage, setVille_maitre_ouvrage] = useState("");
  const [nom_maitre_ouvrage, setNom_maitre_ouvrage] = useState("");
  const [first_name_maitre_ouvrage, setFirst_name_maitre_ouvrage] =
    useState("");
  const [email_maitre_ouvrage, setEmail_maitre_ouvrage] = useState("");
  const [telephone_maitre_ouvrage, setTelephone_maitre_ouvrage] = useState("");
  const [all_articles, setAll_articles] = useState([]);
  const [all_articles_from_approved, setAll_articles_from_approved] = useState(
    []
  );
  const [all_grouparticles_from_approved, setAll_grouparticles_from_approved] =
    useState([]);
  const [selected_articles, setSelected_articles] = useState([]);

  const [all_grouparticles, setAll_grouparticles] = useState([]);
  const [selected_grouparticles, setSelected_grouparticles] = useState([]);
  const [all_selected_articles, setAll_selected_articles] = useState([]);
  const [surface, setSurface] = useState(0);
  const [nombre_maisons, setNombre_maisons] = useState(1);

  const [loadingData, setLoadingData] = useState(false);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [tranches_surface, setTranches_surface] = useState([]);
  const [tranches_maison, setTranches_maison] = useState([]);

  const [dropped_files, setDroppedFiles] = useState([]);
  const [loading_drop = false, setLoadingDrop] = useState(false);
  const [dropped_exists, setDroppedExists] = useState(false);

  const [marque, setMarque] = useState(null);
  const [marques_options, setMarques_options] = useState([]);
  const [available_forms, setAvailable_forms] = useState([]);
  const [forms, setForms] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [forms_filled, setFormsFilled] = useState([]);
  const [audit_config, setAuditConfig] = useState({});
  const [type_client, setTypeClient] = useState(iframe ? "particulier" : null);

  const [comments, setComments] = useState("");

  const [step, setStep] = useState("form");

  // Widget funnel tracking: record each step the visitor reaches so the dashboard
  // can show where people abandon the form. Best-effort, never blocks the UI.
  const maxStepRef = useRef(0);
  useEffect(() => {
    if (!iframe || !iframe.session_id) return;
    const idx = widgetStepIndex(step);
    if (idx < 0) return; // transient step (e.g. "invoice") — submit tracks the rest
    if (idx > maxStepRef.current) maxStepRef.current = idx;
    trackWidgetStep(iframe.master_id, iframe.session_id, step, maxStepRef.current);
  }, [step]);

  // Report whether the visitor has started filling, so EmbedWidget can warn
  // before an accidental close discards their input.
  useEffect(() => {
    if (!iframe || !iframe.onProgress) return;
    const started = step !== "form" || (article_configuration?.step || 0) > 0;
    iframe.onProgress(started);
  }, [step, article_configuration]);

  // Persist the typed contact / address / audit fields in localStorage so a
  // closed or refreshed widget doesn't force the visitor to re-type everything.
  const persistKey = iframe ? `hex_widget_form_${iframe.master_id}` : null;
  const hydratedRef = useRef(false);

  useEffect(() => {
    if (!iframe || !persistKey || hydratedRef.current) return;
    hydratedRef.current = true;
    try {
      const raw = localStorage.getItem(persistKey);
      if (!raw) return;
      const d = JSON.parse(raw);
      if (d.nom_maitre_ouvrage) setNom_maitre_ouvrage(d.nom_maitre_ouvrage);
      if (d.first_name_maitre_ouvrage)
        setFirst_name_maitre_ouvrage(d.first_name_maitre_ouvrage);
      if (d.email_maitre_ouvrage) setEmail_maitre_ouvrage(d.email_maitre_ouvrage);
      if (d.telephone_maitre_ouvrage)
        setTelephone_maitre_ouvrage(d.telephone_maitre_ouvrage);
      if (d.adresse_maitre_ouvrage)
        setAdresse_maitre_ouvrage(d.adresse_maitre_ouvrage);
      if (d.code_postal_maitre_ouvrage)
        setCode_postal_maitre_ouvrage(d.code_postal_maitre_ouvrage);
      if (d.ville_maitre_ouvrage) setVille_maitre_ouvrage(d.ville_maitre_ouvrage);
      if (d.adresse_projet) setAdresse_projet(d.adresse_projet);
      if (d.code_postal_projet) setCode_postal_projet(d.code_postal_projet);
      if (d.ville_projet) setVille_projet(d.ville_projet);
      if (d.audit_config) setAuditConfig(d.audit_config);
      if (d.comments) setComments(d.comments);
    } catch (e) {
      console.warn("widget form hydrate failed", e);
    }
  }, [iframe, persistKey]);

  useEffect(() => {
    if (!iframe || !persistKey || !hydratedRef.current) return;
    try {
      localStorage.setItem(
        persistKey,
        JSON.stringify({
          nom_maitre_ouvrage,
          first_name_maitre_ouvrage,
          email_maitre_ouvrage,
          telephone_maitre_ouvrage,
          adresse_maitre_ouvrage,
          code_postal_maitre_ouvrage,
          ville_maitre_ouvrage,
          adresse_projet,
          code_postal_projet,
          ville_projet,
          audit_config,
          comments,
        })
      );
    } catch (e) {
      // storage full / disabled — ignore, persistence is best-effort
    }
  }, [
    nom_maitre_ouvrage,
    first_name_maitre_ouvrage,
    email_maitre_ouvrage,
    telephone_maitre_ouvrage,
    adresse_maitre_ouvrage,
    code_postal_maitre_ouvrage,
    ville_maitre_ouvrage,
    adresse_projet,
    code_postal_projet,
    ville_projet,
    audit_config,
    comments,
  ]);

  const addArticle = (e, article) => {
    e.stopPropagation();
    const new_articles = [...selected_articles, article];
    setSelected_articles(new_articles);
  };

  useEffect(() => {
    checkAnyFormAvailable();
  }, [selected_articles, selected_grouparticles]);

  const addGroupArticle = (grouparticle) => {
    const new_group_articles = [...selected_grouparticles, grouparticle];
    setSelected_grouparticles(new_group_articles);
  };

  function checkArticleRemiseMaison(article) {
    let desc_remise_maisons = (
      (article && article.remise?.maison_tranches) ||
      []
    ).sort((a, b) => a.maison - b.maison);
    if (article && article.remise?.maison_tranches) {
      for (let i = 0; i < desc_remise_maisons.length; i++) {
        if (nombre_maisons >= desc_remise_maisons[i].maison) {
          return desc_remise_maisons[i].remise;
        }
      }
    }
    return 0;
  }

  function checkArticleSupplementSurface(article) {
    if (article && article.remise?.surface_tranches) {
      for (let i = 0; i < article.remise.surface_tranches.length; i++) {
        if (
          surface > article.remise.surface_tranches[i].surface &&
          surface <= article.remise.surface_tranches[i].surface_max
        ) {
          return article.remise.surface_tranches[i].supplement;
        }
      }
    }
    return 0;
  }

  useEffect(() => {
    let new_all_selected_articles = [...selected_articles];
    // add articles from group articles
    selected_grouparticles.forEach((grouparticle) => {
      grouparticle.articles.forEach((article) => {
        new_all_selected_articles.push(
          all_articles.find((a) => a.id === article.id)
        );
      });
    });
    setAll_selected_articles(new_all_selected_articles);
  }, [selected_articles, selected_grouparticles]);

  function getTotals() {
    const base_ht =
      all_selected_articles.reduce((acc, a) => acc + getArticlePrice(a), 0) *
      nombre_maisons;
    const supplement =
      all_selected_articles.reduce(
        (acc, a) => acc + checkArticleSupplementSurface(a),
        0
      ) + handleSurfaceTranches();

    const total_remise = all_selected_articles
      .filter((a) => checkArticleRemiseMaison(a) !== 0)
      .reduce(
        (acc, a) =>
          acc +
          (getArticlePrice(a) * checkArticleRemiseMaison(a) * nombre_maisons) /
            100,
        0
      );

    // const total_remise = base_ht * (handleMaisonTranches() / 100);
    const total_ht = base_ht + supplement - total_remise;
    const total_ttc = total_ht * 1.2;
    const tva = total_ht * 0.2;
    return { base_ht, tva, total_ht, supplement, total_remise, total_ttc };
  }
  const onDelete = (file) => {
    const new_files = dropped_files.filter((f) => f !== file);
    setDroppedFiles(new_files);
    if (new_files.length === 0) {
      setDroppedExists(false);
    }
  };

  const removeArticle = (article) => {
    const new_articles = selected_articles.filter(
      (a) => a && a?.name !== article?.name
    );
    setSelected_articles(new_articles);
    checkAnyFormAvailable();
  };

  const checkAnyFormAvailable = () => {
    // for each form look at articles selected and if article.form_ref, then add form to available_forms
    const available_forms = [];
    const all_selected_articles = [...selected_articles];

    selected_grouparticles.forEach((grouparticle) => {
      grouparticle.articles.forEach((article) => {
        all_selected_articles.push(
          all_articles.find((a) => a.id === article.id)
        );
      });
    });

    for (let form of forms) {
      let form_available = false;
      for (let article of all_selected_articles) {
        if (article && article?.form_ref && article?.form_ref.id === form.id) {
          form_available = true;
          break;
        }
      }
      if (form_available) {
        available_forms.push(form);
      }
    }
    setAvailable_forms(available_forms);
  };

  const formFilled = (form) => {
    const forms = [...forms_filled];
    forms.push(form);
    setFormsFilled(forms);
  };

  const removeGroupArticle = (grouparticle) => {
    const new_articles = selected_grouparticles.filter(
      (a) => a?.name !== grouparticle?.name
    );
    setSelected_grouparticles(new_articles);
    checkAnyFormAvailable();
  };

  const handleSetClient = (value) => {
    if (value === null) {
      setClientSelected(null);
      setClient(null);
      setSelected_articles([]);
      return;
    }
    let client_value = value;
    const client = clients.find((client) => client.id === client_value);
    setClientSelected(value);
    setClient(client);
    setSelected_articles([]);

    if (client.marques) {
      const marques_options = client.marques.map((marque) => {
        return { value: marque?.name, label: marque?.name };
      });
      setMarques_options(marques_options);
      setMarque(marques_options[0]);
    }
  };

  const onDropZone = async (files) => {
    setLoadingDrop(true);

    let new_files = [];
    const token = await getOrRefreshFirebaseToken();

    new_files = files.filter(
      (file) => !dropped_files.map((filed) => filed?.name).includes(file?.name)
    );

    let new_drop_files = [];

    for (let i = 0; i < new_files.length; i++) {
      let res = await uploadDropZoneTemporary(
        token,
        new_files[i],
        new_files[i]?.name,
        prefix
      );
      let url = res.url;
      let name = res?.name;
      new_drop_files = [...new_drop_files, { url: url, name: name }];
    }
    let new_dropped_files = [...dropped_files, ...new_drop_files];
    setDroppedFiles(new_dropped_files);
    setDroppedExists(true);

    setLoadingDrop(false);
  };

  const transferFiles = async (invoiceid) => {
    try {
      const token = await getOrRefreshFirebaseToken();
      await transferInvoiceFiles(invoiceid, dropped_files, token, prefix);

      setDroppedFiles([]);
      setDroppedExists(false);
    } catch (error) {
      console.error("Error transfering files:", error);
    }
  };

  function getArticlePrice(article) {
    if (!article) return 0;
    if (type_client === "particulier") return parseInt(article.base_price);
    const negoces = master.negoces || [];
    const negoce = negoces.find(
      (negoce) =>
        negoce.article_ref.id === article?.id &&
        negoce.client_o?.id === client.id
    );
    if (negoce) {
      if (typeof negoce.price_ht === "string") {
        let amount = negoce.price_ht.replace(",", ".");
        return parseFloat(amount);
      } else {
        return negoce.price_ht;
      }
    } else {
      const base_price_int = parseInt(article.base_price);
      return base_price_int;
    }
  }

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (!iframe && currentUser) {
      try {
        // Fetch user data

        let client = null;
        let client_selected = null;

        const clients_name = clients.map((client) => {
          return { value: client.id, label: client?.name };
        });
        const sorted_clients_names = clients_name.sort((a, b) =>
          a.label.localeCompare(b.label)
        );
        setClients_options(sorted_clients_names);
        setClients(clients);

        let tranches_surface = orgData.infos?.remise?.surface_tranches || [];
        let tranches_maison = orgData.infos?.remise?.maison_tranches || [];
        setTranches_surface(tranches_surface);
        setTranches_maison(tranches_maison);

        // Update state with fetched data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    if (iframe) {
      let master = await getDocDataById("org", iframe.master_id);

      if (!master) {
        handleClickVariant(
          "Erreur lors de la récupération de l'organisation",
          "error"
        );

        return;
      }
      const filters = [
        {
          field: "org_ref",
          operator: "==",
          value: master.ref,
        },
      ];

      let tranches_surface = orgData.infos?.remise?.surface_tranches || [];
      let tranches_maison = orgData.infos?.remise?.maison_tranches || [];
      setTranches_surface(tranches_surface);
      setTranches_maison(tranches_maison);

      const all_articles = await queryCollection("article", filters);
      const sorted_all_articles = all_articles.sort((a, b) =>
        a?.name.localeCompare(b?.name)
      );
      setAll_articles(sorted_all_articles);

      setMaster(master);

      setClient(null);
      setTypeClient("particulier");
      setClientSelected(null);
      setMarques_options([]);
      setMarque(null);
      setClients_options([]);
    }
  };

  const handleCheckToStep = (step) => {
    if (step === "form") {
      if (surface === 0 && article_configuration.type === "house") {
        handleClickVariant("Veuillez saisir la surface", "error");
        return;
      }
      if (nombre_maisons === 0 && article_configuration.type === "house") {
        handleClickVariant("Veuillez saisir le nombre de maisons", "error");
        return;
      }
      if (
        selected_articles.length === 0 &&
        selected_grouparticles.length === 0
      ) {
        handleClickVariant(
          "Veuillez sélectionner au moins un article",
          "error"
        );
        return;
      }

      let needed_files = [];
      for (let article of all_selected_articles) {
        if (article?.needed_files) {
          let files = article?.needed_files || [];
          for (let i = 0; i < files.length; i++) {
            let file = files[i];
            if (!needed_files.map((f) => f.name).includes(file.name)) {
              needed_files.push(file);
            }
          }
        }
      }
      setNeededFiles(needed_files);

      setStep("infos-1");
    }
    if (step === "infos-1") {
      if (!type_client) {
        handleClickVariant("Veuillez sélectionner un type de client", "error");
        return;
      }
      if (!client && type_client === "pro") {
        handleClickVariant("Veuillez sélectionner un client", "error");
        return;
      }

      if (!nom_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le nom du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!first_name_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le prénom du maître d'ouvrage",

          "error"
        );
        return;
      }
      if (!email_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir l'email du maître d'ouvrage",
          "error"
        );
        return;
      }
      // check if email is valid
      if (!email_maitre_ouvrage.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        handleClickVariant(
          "Veuillez saisir une adresse email valide.",
          "error"
        );
        return;
      }
      if (!telephone_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le téléphone du maître d'ouvrage",
          "error"
        );
        return;
      }

      // The prospect has now entered valid contact details. Persist them on the
      // analytics session so the dashboard can surface people who left their
      // email/phone but never finished the form. Best-effort.
      if (iframe && iframe.session_id) {
        trackWidgetContact(iframe.master_id, iframe.session_id, {
          name: nom_maitre_ouvrage,
          first_name: first_name_maitre_ouvrage,
          email: email_maitre_ouvrage,
          phone: telephone_maitre_ouvrage,
        });
      }

      setStep("infos-2");
    }
    if (step === "infos-2") {
      if (!type_client) {
        handleClickVariant("Veuillez sélectionner un type de client", "error");
        return;
      }
      if (!client && type_client === "pro") {
        handleClickVariant("Veuillez sélectionner un client", "error");
        return;
      }
      if (!adresse_projet) {
        handleClickVariant("Veuillez saisir l'adresse du projet", "error");
        return;
      }
      if (!code_postal_projet) {
        handleClickVariant("Veuillez saisir le code postal du projet", "error");
        return;
      }
      if (!ville_projet) {
        handleClickVariant("Veuillez saisir la ville du projet", "error");
        return;
      }
      if (!adresse_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir l'adresse du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!code_postal_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir le code postal du maître d'ouvrage",
          "error"
        );
        return;
      }
      if (!ville_maitre_ouvrage) {
        handleClickVariant(
          "Veuillez saisir la ville du maître d'ouvrage",
          "error"
        );
        return;
      }

      if (master.config?.widget?.audit) {
        setStep("infos-3");
      } else {
        setStep("files");
      }
    }

    if (step === "infos-3") {
      if (!audit_config?.profil) {
        handleClickVariant("Veuillez sélectionner un profil d'audit", "error");
        return;
      }
      if (!audit_config?.mpr) {
        handleClickVariant("Veuillez choisir une catégorie MPR", "error");
        return;
      }
      if (!audit_config?.foyer_fiscal) {
        handleClickVariant("Veuillez choisir un foyer fiscal", "error");
        return;
      }

      setStep("files");
    }

    if (step === "files") {
      setStep("invoice");
      createInvoice();
    }
  };

  const createInvoice = async () => {
    try {
      setLoadingData(true); // Set loading state to true

      const body = {
        org_id: master.id,
        creation_date: Timestamp.now(), // Firebase Timestamp
        client_o: null,
        state: "draft",
        nom: nom_maitre_ouvrage,
        first_name: first_name_maitre_ouvrage,
        logo_url:
          master.logo ||
          "https://i.ibb.co/CWHxrfX/Hexagone-UXLogo3-LOW-1024.png",
        champs: [],
        forms: [],
        master_name: master?.name,
        master_adresse: master.infos.adresse,
        master_postal: master.infos.postal,
        master_ville: master.infos.ville,
        siret: master.infos.siret,
        num_tva: master.infos.num_tva,
        phone: master.infos.phone,
        email: master.infos.email,
        num_devis: "DEV" + Math.floor(Math.random() * 1000000),
        date: format(new Date(), "dd/MM/yyyy"),
        num_cient: "particulier",
        date_validite: format(addDays(new Date(), 30), "dd/MM/yyyy"),
        nom_client: nom_maitre_ouvrage,
        adresse_client: adresse_maitre_ouvrage,
        postal_client: code_postal_maitre_ouvrage,
        ville_client: ville_maitre_ouvrage,
        adresse_projet: adresse_projet,
        postal_projet: code_postal_projet,
        ville_projet: ville_projet,
        banque: master.infos.banque,
        iban: master.infos.iban,
        bic: master.infos.bic,
        prix_tot_ttc: getTotals().total_ttc,
        politique_annulation: master.infos.politique_annulation,
        conditions_reglement: master.infos.conditions_reglement,
        politique_echec: master.infos.politique_echec,
        email_client: email_maitre_ouvrage,
        tel_client: telephone_maitre_ouvrage,

        articles: [],
        surface: surface,
        nombre_maisons: nombre_maisons,
        base_ht: getTotals().base_ht,
        supplement: getTotals().supplement,
        total_remise: getTotals().total_remise,
        total_ht: getTotals().total_ht,
        tva: getTotals().tva,
        total_ttc: getTotals().total_ttc,
        marque: "Particulier",
        client_type: "particulier",
        history_events: [
          {
            date: Timestamp.now(),
            name: "Création du brouillon",
          },
        ],
        author: "website",
        structure_type:
          article_configuration.type === "house"
            ? "maison_individuelle"
            : "extension",
        article_configuration: article_configuration,
        audit_config: audit_config,
        comments: comments,
      };

      const new_devis = await createDocApi("devis", body, prefix);
      let token = await getOrRefreshFirebaseToken();
      // wait for the url to be generated
      if (dropped_files.length > 0) {
        await transferFiles(new_devis.id);
      }

      handleClickVariant("Devis créé avec succès", "success");

      iframe.setSuccess(true);

      // Mark the funnel as converted (best-effort).
      trackWidgetSubmit(master.id, iframe.session_id, new_devis?.id, {
        total_ttc: getTotals().total_ttc,
        articles_count: all_selected_articles.length,
      });

      // Clear the saved draft now that the devis is submitted.
      try {
        if (persistKey) localStorage.removeItem(persistKey);
      } catch (e) {
        // ignore
      }

      setLoadingData(false); // Set loading state to false

      token = await getOrRefreshFirebaseToken();
      await sendEmailDraftInvoiceCreated(new_devis.id, token, prefix);
    } catch (error) {
      console.error("Error creating invoice:", error);
      handleClickVariant("Erreur lors de la création du devis", "error");
      setLoadingData(false); // Set loading state to false
    }
  };

  function handleSurfaceTranches() {
    for (let i = 0; i < tranches_surface.length; i++) {
      if (
        surface > tranches_surface[i].surface &&
        surface <= tranches_surface[i].surface_max
      ) {
        return tranches_surface[i].addition;
      }
    }
    return 0;
  }

  useEffect(() => {
    setSurface(article_configuration?.surface || 0);
    setNombre_maisons(article_configuration?.units || 1);

    let filterd_articles = all_articles.filter((article) => {
      let config = article.devis_form_configuration || {};
      return (
        (!config.type || config.type === article_configuration.type) &&
        (!config.extension_type ||
          article_configuration.extension_type === null ||
          config.extension_type === article_configuration.extension_type) &&
        (!config.package || config.package === article_configuration.package) &&
        (!config.pmr || config.pmr === article_configuration.pmr)
      );
    });

    let visibleee = filterd_articles.filter((a) =>
      type_client === "pro"
        ? a.visibility
          ? a.visibility[client_selected] === true
          : false
        : true
    );

    visibleee = visibleee.filter((a) =>
      iframe ? a.widget_enabled === true : true
    );

    setAll_articles_from_approved(visibleee);

    setSelected_articles(visibleee?.length > 0 ? [visibleee[0]] : []);
    // filter group articles based on form approved articles
    let filter_visible_grouparticles = [];
    for (let grouparticle of all_grouparticles) {
      let add_it = true;
      let articles = all_articles.filter((a) =>
        grouparticle.articles.map((ref) => ref.id).includes(a.id)
      );
      // I want all to be in the filterd_articles
      if (
        articles.some((a) => !filterd_articles.map((a) => a.id).includes(a.id))
      ) {
        add_it = false;
      }
      if (add_it) {
        filter_visible_grouparticles.push(grouparticle);
      }
    }
    setAll_grouparticles_from_approved(filter_visible_grouparticles);
    setSelected_grouparticles([]);
  }, [article_configuration, client_selected]);

  const [openDescription, setOpenDescription] = useState(null);

  useEffect(() => {
    if (currentUser || iframe.master_id) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser, iframe]); // Dependency array ensures this runs when currentUser changes

  // Function to create a new client
  // loading || !currentUser || !userData
  if (iframe ? false : loading || !currentUser || !userData) {
    return (
      <div className="w-full h-full overflow-auto flex flex-row">
        <Spin></Spin>
      </div>
    );
  }

  return (
    <div className={`h-full overflow-auto flex min-h-c400 w-full`}>
      {/* Left Column: Takes all available space */}

      <Modal1 isOpen={openDescription} onClose={() => setOpenDescription(null)}>
        <div className="flex flex-col p-4 bg-white rounded-xl max-w-c400">
          <div className="text-h1 font-semibold">{openDescription?.name}</div>
          <Space y={10} />
          <div className="text-h3 text-shadow_50">
            {openDescription?.description}
          </div>
          <Space y={10} />
          <div className="text-h3 text-shadow_50">
            {"Prix HT: " + formatToEuro(getArticlePrice(openDescription))}
          </div>
        </div>
      </Modal1>

      <Modal1 isOpen={formOpen} onClose={() => setFormOpen(null)}>
        <FillFormModal
          orgData={orgData}
          form_id={formOpen?.id}
          onClose={() => setFormOpen(null)}
          formFilled={formFilled}
          prefix={prefix}
        ></FillFormModal>
      </Modal1>

      {/* Right Column: Fixed width */}
      <div className="flex flex-col gap-1 h-fit px-4 w-full ">
        <div className={`text-hx font-semibold ${mobile ? "mb-2" : ""}`}>
          Nouveau Devis
        </div>
        {/* Compact progress bar — the full timeline is hidden on mobile, leaving
            visitors with no sense of how far they are through the form. */}
        {mobile &&
          (() => {
            const stepOrder = [
              "form",
              "infos-1",
              "infos-2",
              ...(master?.config?.widget?.audit ? ["infos-3"] : []),
              "files",
            ];
            const idx = stepOrder.indexOf(step);
            if (idx < 0) return null;
            const pct = Math.round((idx / (stepOrder.length - 1)) * 100);
            return (
              <div className="flex flex-col gap-1 mb-3">
                <div className="flex flex-row justify-between text-h4 text-shadow_50">
                  <span>
                    Étape {idx + 1} sur {stepOrder.length}
                  </span>
                  <span>{pct}%</span>
                </div>
                <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-blue-400 rounded-full transition-all"
                    style={{ width: `${pct}%` }}
                  ></div>
                </div>
              </div>
            );
          })()}
        {/* Live price estimate while filling the info steps — keeps the visitor
            motivated to reach the end. */}
        {["infos-1", "infos-2", "infos-3", "files"].includes(step) &&
          all_selected_articles.length > 0 && (
            <div className="flex flex-row items-center justify-between border border-blue-100 bg-blue-50 rounded-xl px-3 py-2 mb-2">
              <span className="text-h4 text-shadow_50">Estimation</span>
              <span className="text-h2 font-semibold text-black">
                {formatToEuro(getTotals().total_ttc)} TTC
              </span>
            </div>
          )}
        <div
          className={`my-6 min-h-fit max-w-c800 w-fit  ${
            mobile ? "hidden" : "block"
          }`}
        >
          <TimelineNewInvoice step={step}></TimelineNewInvoice>
        </div>{" "}
        <div className="flex flex-row gap-4 pb-10 pr-4 w-full h-fit">
          <div className="flex flex-col gap-2 w-full ">
            {step === "infos-1" && (
              <div className="flex flex-col gap-2 max-w-c500 ">
                <div className="text-h1 font-semibold">Informations Devis</div>
                <Space y={5} />
                <div className="text-h3 text-shadow_50">
                  Remplissez les champs ci-dessous pour compléter les
                  informations du devis.
                </div>

                <div className="w-full  flex flex-col gap-2">
                  <TextField2T
                    label="Nom du maître d'ouvrage"
                    mandatory={true}
                    value={nom_maitre_ouvrage}
                    onChange={(e) => setNom_maitre_ouvrage(e.target.value)}
                  ></TextField2T>
                  <TextField2T
                    label="Prénom du maître d'ouvrage"
                    mandatory={true}
                    value={first_name_maitre_ouvrage}
                    onChange={(e) =>
                      setFirst_name_maitre_ouvrage(e.target.value)
                    }
                  ></TextField2T>
                  <TextField2T
                    label="Adresse email du maître d'ouvrage"
                    mandatory={true}
                    value={email_maitre_ouvrage}
                    onChange={(e) => setEmail_maitre_ouvrage(e.target.value)}
                    type={"email"}
                  ></TextField2T>
                  <TextField2T
                    label="Téléphone personnel du maître d'ouvrage"
                    mandatory={true}
                    value={telephone_maitre_ouvrage}
                    onChange={(e) =>
                      setTelephone_maitre_ouvrage(e.target.value)
                    }
                    type="phone"
                  ></TextField2T>
                </div>
                <div className="flex flex-row justify-end w-full gap-2 mt-2">
                  {" "}
                  <SecondaryButton
                    mobile={mobile}
                    onClick={() => setStep("form")}
                  >
                    Retour
                  </SecondaryButton>
                  <PrimaryButton
                    mobile={mobile}
                    className="w-fit"
                    disabled={
                      !nom_maitre_ouvrage ||
                      !first_name_maitre_ouvrage ||
                      !email_maitre_ouvrage ||
                      !telephone_maitre_ouvrage
                    }
                    onClick={() => handleCheckToStep("infos-1")}
                  >
                    Continuer
                  </PrimaryButton>
                </div>
              </div>
            )}{" "}
            {step === "infos-2" && (
              <div className="flex flex-col gap-2 max-w-c500 ">
                <div className="text-h1 font-semibold">Informations Devis</div>
                <Space y={5} />
                <div className="text-h3 text-shadow_50">
                  Remplissez les champs ci-dessous pour compléter les
                  informations du devis.
                </div>

                <div className="w-full  flex flex-col gap-2">
                  <Space y={10} />
                  <TextField2T
                    className="w-full"
                    label="Adresse actuelle du maitre d'ouvrage"
                    mandatory={true}
                    value={adresse_maitre_ouvrage}
                    onChange={(e) => setAdresse_maitre_ouvrage(e.target.value)}
                  ></TextField2T>
                  <div className="flex flex-row justify-between w-full gap-2">
                    <TextField2T
                      className="w-full"
                      label="Code postal"
                      mandatory={true}
                      value={code_postal_maitre_ouvrage}
                      onChange={(e) =>
                        setCode_postal_maitre_ouvrage(e.target.value)
                      }
                    ></TextField2T>
                    <TextField2T
                      className="w-full"
                      label="Ville"
                      mandatory={true}
                      value={ville_maitre_ouvrage}
                      onChange={(e) => setVille_maitre_ouvrage(e.target.value)}
                    ></TextField2T>
                  </div>
                  <Space y={10} />

                  <TextField2T
                    className="w-full"
                    label="Adresse du projet"
                    mandatory={true}
                    value={adresse_projet}
                    onChange={(e) => setAdresse_projet(e.target.value)}
                  ></TextField2T>
                  <div className="flex flex-row justify-between w-full gap-2">
                    <TextField2T
                      className="w-full"
                      label="Code postal"
                      mandatory={true}
                      value={code_postal_projet}
                      onChange={(e) => setCode_postal_projet(e.target.value)}
                    ></TextField2T>
                    <TextField2T
                      className="w-full"
                      label="Ville"
                      mandatory={true}
                      value={ville_projet}
                      onChange={(e) => setVille_projet(e.target.value)}
                    ></TextField2T>
                  </div>
                </div>
                <div className="flex flex-row justify-end w-full gap-2 mt-2">
                  {" "}
                  <SecondaryButton
                    mobile={mobile}
                    onClick={() => setStep(step - 1)}
                  >
                    Retour
                  </SecondaryButton>
                  <PrimaryButton
                    mobile={mobile}
                    className="w-fit"
                    disabled={
                      !nom_maitre_ouvrage ||
                      !first_name_maitre_ouvrage ||
                      !email_maitre_ouvrage ||
                      !adresse_projet ||
                      !code_postal_projet ||
                      !ville_projet ||
                      !adresse_maitre_ouvrage ||
                      !code_postal_maitre_ouvrage ||
                      !ville_maitre_ouvrage ||
                      !telephone_maitre_ouvrage
                    }
                    onClick={() => handleCheckToStep("infos-2")}
                  >
                    Continuer
                  </PrimaryButton>
                </div>
              </div>
            )}{" "}
            {step === "infos-3" && (
              <div className="flex flex-col gap-2 max-w-c500 ">
                <div className="text-h1 font-semibold">Informations Devis</div>
                <Space y={5} />
                <div className="text-h3 text-shadow_50">
                  Remplissez les champs ci-dessous pour compléter les
                  informations du devis.
                </div>

                <DropDownGPT03
                  force_down={true}
                  items={audit_profil_options}
                  className="w-full"
                  label="Profil particulier"
                  value={audit_config.profil}
                  onChange={(e) =>
                    setAuditConfig({
                      ...audit_config,
                      profil: e.value,
                    })
                  }
                ></DropDownGPT03>
                <DropDownGPT03
                  items={audit_mpr_options}
                  className="w-full"
                  force_down={true}
                  label="Catégorie MPR"
                  value={audit_config.mpr}
                  onChange={(e) =>
                    setAuditConfig({
                      ...audit_config,
                      mpr: e.value,
                    })
                  }
                ></DropDownGPT03>
                <TextField2T
                  label="Nombre de personnes dans le foyer fiscal"
                  value={audit_config.foyer_fiscal || ""}
                  mandatory={false}
                  onChange={(e) =>
                    setAuditConfig({
                      ...audit_config,
                      foyer_fiscal: e.target.value,
                    })
                  }
                  transparent={false}
                ></TextField2T>

                <div className="flex flex-row justify-end w-full gap-2 mt-2">
                  {" "}
                  <SecondaryButton
                    mobile={mobile}
                    onClick={() => setStep("infos-2")}
                  >
                    Retour
                  </SecondaryButton>
                  <PrimaryButton
                    mobile={mobile}
                    className="w-fit"
                    disabled={
                      !audit_config.profil ||
                      !audit_config.mpr ||
                      !audit_config.foyer_fiscal
                    }
                    onClick={() => handleCheckToStep("infos-3")}
                  >
                    Continuer
                  </PrimaryButton>
                </div>
              </div>
            )}{" "}
            {step === "files" && (
              <div className="flex flex-col max-w-c500 h-fit">
                <Space y={20} />

                {(!iframe || display_final) && (
                  <div className="flex flex-col  justify-start items-start max-w-c500 h-fit">
                    <div className="text-h1 font-semibold">
                      Pièces à déposer
                    </div>
                    <Space y={5} />
                    <div className="text-h3 text-shadow_50">
                      Déposez les plans si possible. (optionnel)
                    </div>
                    <Space y={10} />
                    <div className="flex max-h-c200 w-full items-start justify-start">
                      <Dropzone2
                        onDrop={onDropZone}
                        files={dropped_files || []}
                        onDelete={onDelete}
                        loading={loading_drop}
                        instructionsText="Glissez ou déposez les documents ici"
                      ></Dropzone2>
                    </div>{" "}
                    <MLTFGPT3
                      label={"Commentaires et instructions pour le devis"}
                      value={comments}
                      rows={6}
                      onChange={(e) => setComments(e.target.value)}
                    ></MLTFGPT3>
                    <Space y={20} />
                  </div>
                )}
                {iframe && !display_final && (
                  <RecaptchaComponent
                    iframe={iframe}
                    mobile={mobile}
                    email={email_maitre_ouvrage || ""}
                    actionText="Je suis humain"
                    handleSuccess={() => setDisplayFinal(true)}
                  ></RecaptchaComponent>
                )}
                <div className="flex flex-row justify-end w-full gap-2 mt-4">
                  <SecondaryButton
                    mobile={mobile}
                    onClick={() => setStep(step - 1)}
                  >
                    Retour
                  </SecondaryButton>
                  {(!iframe || display_final) && (
                    <PrimaryButton
                      mobile={mobile}
                      className="w-fit"
                      disabled={
                        available_forms.length > 0 &&
                        forms_filled.length !== available_forms.length
                      }
                      onClick={() => handleCheckToStep("files")}
                    >
                      Générer le devis
                    </PrimaryButton>
                  )}
                </div>
              </div>
            )}
            {step === "invoice" && (
              <div className="flex flex-row gap-4 max-w-c500">
                <Space y={20} />
                <div className="text-h3 text-shadow_50">
                  Génération du devis en cours...
                </div>
                <Spin />
              </div>
            )}
            {step === "form" && (
              <div className="w-full flex flex-col justify-start ">
                <NewInvoiceForm
                  mobile={mobile}
                  setStep={setStep}
                  article_configuration={article_configuration}
                  setArticle_configuration={setArticle_configuration}
                ></NewInvoiceForm>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewInvoiceClient;

export function formatToEuro(amount) {
  // Convert the float to a string with two decimal places and replace '.' with ','
  if (typeof amount === "string") {
    amount = amount.replace(".", ",");
    amount = parseFloat(amount);
  }
  const formattedAmount = amount.toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${formattedAmount}€`;
}

export const audit_profil_options = [
  { value: "proprietaire_occupant", label: "Propriétaire occupant" },
  { value: "proprietaire_bailleur", label: "Propriétaire bailleur" },
  { value: "locataire", label: "Locataire" },
  { value: "bailleur_social", label: "Bailleur social" },
  { value: "sci", label: "SCI" },
  { value: "autre", label: "Autre" },
];
export const audit_mpr_options = [
  { value: "tres_modeste", label: "Très modeste" },
  { value: "modeste", label: "Modeste" },
  { value: "intermediaire", label: "Intermédiaire" },
  { value: "superieure", label: "Supérieure" },
  { value: "autre", label: "Autre" },
];
